module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArBAMAAADWAfZiAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMAQFAj4sZ+Erq7SSWN+zAAAABLSURBVDjLY2BgFsQJDICy0btxgq0GDCW78QB3hmx80tsYuvFJ78AvvZOA4QScRshjDMyLlHAALQOGYQwGa3LYOZociACjyYEeyQEAIG0KsR+nn7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/menu.png
// module id = Jvgh
// module chunks = 1